import type { ReactNode } from "react";
import { Chip } from "@mui/material";
import type { SxProps } from "@mui/material";
import { PersonneDataSource } from "models";

interface PersonneSourceChipProps {
  source: PersonneDataSource;
  sx?: SxProps;
}

function PersonneSourceChip({ source, sx }: Readonly<PersonneSourceChipProps>): ReactNode {
  return <Chip size="small" sx={sx} label={`Source : ${source ?? PersonneDataSource.RNE}`} />;
}

export default PersonneSourceChip;
